import { LinearProgress } from "@mui/material";
import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
const ConfirmPhoneScreen = lazy(() => import("./registration/confirm-phone"));
const CongratulationScreen = lazy(() => import("./registration/congratulation"));
const CreateUserScreen = lazy(() => import("./registration/create-user"));
const EnterCredentialScreen = lazy(() => import("./registration/enter-credential"));
const EnterPhoneScreen = lazy(() => import("./registration/enter-phone"));
const HomeScreen = lazy(() => import("./tabs/home"));
const LoginScreen = lazy(() => import("./login"));
const UpgradeScreen = lazy(() => import("./upgrade"));
const PayResultScreen = lazy(() => import("./pay-result"));
const WelcomeScreen = lazy(() => import("./welcome"));
const MyGenresScreen = lazy(() => import("./my-genres"));
const SplashScreen = lazy(() => import("./splash"));
const BottomNavigationLayout = lazy(() => import("./tabs/bottom-navigation"));
const ProfileScreen = lazy(() => import("./tabs/profile"));
const AllScreen = lazy(() => import("./all"));
const SuggestionScreen = lazy(() => import("./suggestion"));
const AlbumScreen = lazy(() => import("./album"));
const PlaylistScreen = lazy(() => import("./playlist"));
const GenrePlaylistScreen = lazy(() => import("./genre-playlist"));
const ModePlaylistScreen = lazy(() => import("./mode-playlist"));
const ArtistScreen = lazy(() => import("./artist"));
const PlayerScreen = lazy(() => import("./player"));
const QueueScreen = lazy(() => import("./queue"));
const SearchScreen = lazy(() => import("./tabs/search"));
const EditablePlaylistScreen = lazy(() => import("./editable-playlist"));
const EditUserScreen = lazy(() => import("./edit-user"));
const SearchInArtistScreen = lazy(() => import("./search-in-artist"));
const UserScreen = lazy(() => import("./user"));
const NotificationsScreen = lazy(() => import("./notifications"));
const FriendsScreen = lazy(() => import("./friends"));
const WelcomeToMatchMakerScreen = lazy(() => import("./match/welcome"));
const EditBirthdateScreen = lazy(() => import("./match/edit-birthdate"));
const EditGendersScreen = lazy(() => import("./match/edit-genders"));
const UploadImagesScreen = lazy(() => import("./match/upload-images"));
const SettingsScreen = lazy(() => import("./match/settings"));
const MatchedScreen = lazy(() => import("./match/matched"));
const ChatScreen = lazy(() => import("./chat"));
const ChatsScreen = lazy(() => import("./chats"));
const ArchiveScreen = lazy(() => import("./tabs/archive"));
const MatchMakerScreen = lazy(() => import("./match/match-maker"));
const MatchMakerTbdScreen = lazy(() => import("./match/match-maker-tbd"));
const MatchCongratulationScreen = lazy(() => import("./match/congratulation"));
const MatchSplashScreen = lazy(() => import("./match/splash"));
const EnterPhoneForgotPasswordScreen = lazy(() => import("./forgot-password/enter-phone"));
const ConfirmPhoneForgotPasswordScreen = lazy(() => import("./forgot-password/confirm-phone"));
const EnterCredentialForgotPasswordScreen = lazy(() => import("./forgot-password/enter-credential"));

export const RootRouter = () => {
  return (
    <Suspense fallback={<LinearProgress />}>
      <Routes>
        <Route path={"/"} element={<SplashScreen />} />
        <Route path={"/welcome"} element={<WelcomeScreen />} />
        <Route path={"registration"}>
          <Route path={"enter-phone"} element={<EnterPhoneScreen />} />
          <Route path={"confirm-phone/:phone"} element={<ConfirmPhoneScreen />} />
          <Route
            path={"enter-credential/:phone"}
            element={<EnterCredentialScreen />}
          />
          <Route path={"create-user/:phone"} element={<CreateUserScreen />} />
          <Route
            path={"congratulation/:firstName"}
            element={<CongratulationScreen />}
          />
          <Route path={"my-genres"} element={<MyGenresScreen isTheFirstTime />} />
        </Route>
        <Route path={"/upgrade"} element={<UpgradeScreen />} />
        <Route path={"/payResult"} element={<PayResultScreen />} />
        <Route path={"/login"} element={<LoginScreen />} />
        <Route path={"/forgot-password"}>
          <Route
            path={"enter-phone"}
            element={<EnterPhoneForgotPasswordScreen />}
          />
          <Route
            path={"confirm-phone/:phone"}
            element={<ConfirmPhoneForgotPasswordScreen />}
          />
          <Route
            path={"enter-credential"}
            element={<EnterCredentialForgotPasswordScreen />}
          />
        </Route>
        <Route path={"/tabs"} element={<BottomNavigationLayout />}>
          <Route path={"home"} element={<HomeScreen />} />
          <Route path={"profile"} element={<ProfileScreen />} />
          <Route path={"search"} element={<SearchScreen />} />
          <Route path={"archive"} element={<ArchiveScreen />} />
          <Route path={"match-maker"} element={<MatchMakerTbdScreen />} />
        </Route>
        <Route path={"/all/:entity"} element={<AllScreen />} />
        <Route path={"/genres/:genreId/playlists"} element={<GenrePlaylistScreen />} />
        <Route path={"/genres/:genreId/:entity"} element={<AllScreen />} />
        <Route path={"/modes/:modeId/playlists"} element={<ModePlaylistScreen />} />
        <Route path={"/artists/:artistId/:entity"} element={<AllScreen />} />
        <Route path={"/users/:userId/:entity"} element={<AllScreen />} />
        <Route
          path={"/suggestions/:suggestionId"}
          element={<SuggestionScreen />}
        />
        <Route path={"/albums/:albumId"} element={<AlbumScreen />} />
        <Route path={"/playlists/:playlistId"} element={<PlaylistScreen />} />
        <Route
          path={"/editable-playlists/:playlistId"}
          element={<EditablePlaylistScreen />}
        />
        <Route path={"/artists/:artistId"} element={<ArtistScreen />} />
        <Route
          path={"/artists/:artistId/search"}
          element={<SearchInArtistScreen />}
        />
        <Route path={"/player"} element={<PlayerScreen />} />
        <Route path={"/queue"} element={<QueueScreen />} />
        <Route path={"/my-genres"} element={<MyGenresScreen />} />
        <Route path={"/edit-user"} element={<EditUserScreen />} />
        <Route path={"/users/:userId"} element={<UserScreen />} />
        <Route path={"/notifications"} element={<NotificationsScreen />} />
        <Route path={"/users/:userId/friends"} element={<FriendsScreen />} />
        <Route path={"/match/splash"} element={<MatchSplashScreen />} />
        <Route path={"/match/welcome"} element={<WelcomeToMatchMakerScreen />} />
        <Route path={"/match/edit-birthdate"} element={<EditBirthdateScreen />} />
        <Route path={"/match/edit-genders"} element={<EditGendersScreen />} />
        <Route path={"/match/upload-images"} element={<UploadImagesScreen />} />
        <Route
          path={"/match/congratulation"}
          element={<MatchCongratulationScreen />}
        />
        <Route path={"/match/match-maker"} element={<MatchMakerScreen />} />
        <Route
          path={"/match/matched/:userId/:imageId"}
          element={<MatchedScreen />}
        />
        <Route path={"/match/matched/:userId"} element={<MatchedScreen />} />
        <Route path={"/match/settings"} element={<SettingsScreen />} />
        <Route path={"/chats/:chatId"} element={<ChatScreen />} />
        <Route path={"/users/:userId/chat"} element={<ChatScreen />} />
        <Route path={"/chats"} element={<ChatsScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};
